{
  "banner.close": "Close",
  "jasenedut.allCategories": "All benefits",
  "jasenedut.cityFilterAll": "All cities",
  "jasenedut.cityFilterLabel": "City",
  "jasenedut.demoDisclosure": "Example content: these benefits are demo examples, not genuine partner offers.",
  "jasenedut.empty": "No benefits available.",
  "jasenedut.heading": "Benefits and discounts",
  "jasenedut.linkLabel": "Read more here",
  "jasenedut.linkNewTabHint": "(opens in a new tab)",
  "jasenedut.showDetails": "Show details",
  "login.disclaimer.demoIntent": "This view is for testing only. Normally this step would use strong authentication.",
  "login.heading": "Sign in",
  "analytics.consent.notice.accept": "Allow measurement",
  "analytics.consent.notice.body": "By allowing usage measurement, you help YTK understand which Oma+ features are used and how the service works. This information is used to improve the service. Administrators see summaries in reports, not your name or member number.\n\nMeasurement can link your usage information across visits and devices. Measurement is optional: you can also use Oma+ without it and change your choice at any time in My info.",
  "analytics.consent.notice.failed": "The choice was not saved. Measurement remains off.",
  "analytics.consent.notice.dismiss": "Close measurement choice",
  "analytics.consent.notice.heading": "Help improve Oma+",
  "analytics.consent.notice.refuse": "Do not allow measurement",
  "analytics.consent.notice.retry": "Try again",
  "analytics.consent.notice.saving": "Saving…",
  "analytics.consent.notice.stale": "The choice changed on another device. Check the current choice and choose again.",
  "analytics.consent.profile.accepted": "Allowed. You can withdraw website-use measurement at any time.",
  "analytics.consent.profile.currentChoice": "Current choice",
  "analytics.consent.profile.disabled": "Measurement is not enabled.",
  "analytics.consent.profile.enable": "Allow measurement",
  "analytics.consent.profile.heading": "Help improve Oma+",
  "analytics.consent.profile.retryWithdraw": "Try withdrawing consent again",
  "analytics.consent.profile.withdraw": "Withdraw measurement permission",
  "analytics.consent.notice.unavailable": "The measurement choice could not be checked. Measurement remains off.",
  "messages.empty": "No messages",
  "messages.title": "Messages",
  "myData.audit.count": "Log events about you",
  "myData.audit.earliest": "Earliest event",
  "myData.audit.heading": "Audit log",
  "myData.analytics.active": "Active use",
  "myData.analytics.active.missing": "Active use was not measured",
  "myData.analytics.attribution.unavailable": "Unavailable",
  "myData.analytics.campaignMedium": "Campaign medium",
  "myData.analytics.campaignName": "Campaign name",
  "myData.analytics.campaignSource": "Campaign source",
  "myData.analytics.device.desktop": "Desktop computer",
  "myData.analytics.device.mobile": "Mobile device",
  "myData.analytics.device.tablet": "Tablet",
  "myData.analytics.device.unknown": "Unknown device",
  "myData.analytics.empty": "No website usage data has been stored.",
  "myData.analytics.entryDevice": "Entry device",
  "myData.analytics.entryLanguage": "Entry language",
  "myData.analytics.entrySource": "Entry source",
  "myData.analytics.error.render": "Rendering error",
  "myData.analytics.error.resourceLoad": "Resource loading error",
  "myData.analytics.error.routeLoad": "View loading error",
  "myData.analytics.error.unhandled": "Unhandled error",
  "myData.analytics.errors": "Error measurements",
  "myData.analytics.errors.none": "No error measurements were recorded",
  "myData.analytics.heading": "Website usage data",
  "myData.analytics.language.en": "English",
  "myData.analytics.language.fi": "Finnish",
  "myData.analytics.language.sv": "Swedish",
  "myData.analytics.language.unknown": "Unknown language",
  "myData.analytics.load.document": "Document load",
  "myData.analytics.load.route": "View load",
  "myData.analytics.loadingNext": "Loading next page…",
  "myData.analytics.loads": "Load measurements",
  "myData.analytics.loads.none": "No load measurements were recorded",
  "myData.analytics.nextPage": "Show next page",
  "myData.analytics.occurredAt": "Time",
  "myData.analytics.page": "Page",
  "myData.analytics.pageError": "Could not load the next page. Please try again.",
  "myData.analytics.quality": "Measurement quality",
  "myData.analytics.quality.measured": "Complete measurement",
  "myData.analytics.quality.partial": "Partial measurement",
  "myData.analytics.quality.unavailable": "Measurement unavailable",
  "myData.analytics.referrerHost": "Referring website domain",
  "myData.analytics.retry": "Try again",
  "myData.analytics.source.direct": "Direct visit",
  "myData.analytics.source.email": "Email",
  "myData.analytics.source.paid": "Paid advertising",
  "myData.analytics.source.referral": "Referring site",
  "myData.analytics.source.search": "Search engine",
  "myData.analytics.source.social": "Social media",
  "myData.analytics.source.unknown": "Unknown source",
  "myData.analytics.unavailable": "Website usage data is not available right now.",
  "myData.successfulMemberMessages.category.jasenasiat": "Member affairs",
  "myData.successfulMemberMessages.category.lakikaveri": "Lakikaveri",
  "myData.successfulMemberMessages.empty": "No successful sent messages have been recorded.",
  "myData.successfulMemberMessages.heading": "Successful sent messages",
  "myData.successfulMemberMessages.kind.initial": "Initial contact",
  "myData.successfulMemberMessages.kind.reply": "Reply",
  "myData.successfulMemberMessages.loadingNext": "Loading next page…",
  "myData.successfulMemberMessages.messageKind": "Message type",
  "myData.successfulMemberMessages.nextPage": "Show next page",
  "myData.successfulMemberMessages.occurredAt": "Time",
  "myData.successfulMemberMessages.pageError": "Could not load the next page. Please try again.",
  "myData.successfulMemberMessages.retry": "Try again",
  "myData.successfulMemberMessages.serviceCategory": "Service category",
  "myData.successfulMemberMessages.unavailable": "Successful sent-message data is not available right now.",
  "myData.contactVerification.heading": "Contact-details check",
  "myData.contactVerification.lastVerified": "Last verified",
  "myData.contactVerification.never": "You have not verified your contact details yet.",
  "myData.languageSetting.heading": "Language choice",
  "myData.languageSetting.chosen": "Chosen language",
  "myData.languageSetting.never": "You have not chosen a language. The app is shown in Finnish.",
  "myData.languageSetting.language.en": "English",
  "myData.languageSetting.language.fi": "Finnish",
  "myData.languageSetting.language.sv": "Swedish",
  "myData.feedback.empty": "You have not submitted feedback.",
  "myData.feedback.heading": "Feedback you have submitted",
  "myData.feedback.rating": "Rating",
  "myData.intro": "This page shows, in one place, the data the application holds about you. Each category indicates whether it is managed in this application or in another service.",
  "myData.legacy.heading": "Data managed in other services",
  "myData.legacy.messaging.note": "Your messages with YTK are managed in the OmaYTK service. The application reads them from there and stores no copy.",
  "myData.ownership.app": "Managed in this application",
  "myData.ownership.legacy": "Managed in another service",
  "myData.profile.email": "Email",
  "myData.profile.heading": "Profile",
  "myData.profile.memberNumber": "Member number",
  "myData.profile.name": "Name",
  "profile.admin.heading": "Administrator",
  "profile.back": "Back",
  "profile.certificate.download": "Download membership certificate",
  "profile.certificate.downloadError": "Downloading the certificate failed. Please try again.",
  "profile.certificate.downloaded": "Membership certificate downloaded.",
  "profile.certificate.downloading": "Generating your membership certificate…",
  "profile.certificate.feePaid": "Paid",
  "profile.certificate.feeUnpaid": "Unpaid",
  "profile.certificate.feeStatus": "Membership fee status",
  "profile.certificate.heading": "Membership certificate",
  "profile.certificate.issuedAt": "Date",
  "profile.certificate.memberName": "Name",
  "profile.certificate.memberNumber": "Member number",
  "profile.certificate.startDate": "Membership start date",
  "profile.certificate.contactService": "The membership certificate cannot be created because your membership details are incomplete. Please contact member services.",
  "profile.certificate.unavailable": "The membership certificate is not available right now. Please try again later.",
  "profile.contact.email": "Email",
  "profile.contact.heading": "Contact details",
  "profile.contact.phone": "Phone",
  "profile.contact.syncNotice": "Your contact details are synchronised between YTK Työelämä and YTK Työttömyyskassa. If you wish, you can manage your consent to contact-detail synchronisation in YTK Työttömyyskassa's",
  "profile.contact.syncNoticeLink": "OmaYTK service",
  "profile.fee.account": "Account number",
  "profile.fee.amount": "Amount",
  "profile.fee.bank": "Bank",
  "profile.fee.billingMethod": "Billing method",
  "profile.fee.copyAccount": "Copy account number",
  "profile.fee.copyReference": "Copy reference number",
  "profile.fee.dueDate": "Due date",
  "profile.fee.empty": "No invoices.",
  "profile.fee.eInvoice.guidance": "Your membership-fee invoices currently arrive on paper. You can switch to e-invoicing, and they will then arrive directly in your online bank.",
  "profile.fee.eInvoice.methodPaper": "Paper invoice",
  "profile.fee.eInvoice.methodEInvoice": "E-invoice",
  "profile.fee.eInvoice.methodUnknown": "Your delivery method could not be determined right now.",
  "profile.fee.eInvoice.pending": "E-invoice proposal requested {date}\n\nWe sent the proposal to your online bank. Approve it there and the delivery method will change to e-invoice. You can request a new proposal from {again} at the earliest.",
  "profile.fee.eInvoice.unavailable": "Billing details could not be loaded right now. Please try again shortly.",
  "profile.fee.eInvoice.submitting": "Sending the e-invoice proposal…",
  "profile.fee.eInvoice.unconfirmed": "We could not confirm your e-invoice proposal request. The proposal is most likely still on its way to your online bank. Check your online bank in a few business days before you request a new proposal.",
  "profile.fee.eInvoice.errorAlreadyRequested": "You already have an e-invoice proposal pending. Please approve it in your online bank.",
  "profile.fee.eInvoice.errorUnsupportedBank": "The bank you selected cannot be used for an e-invoice proposal right now. Please choose another bank or try again later.",
  "profile.fee.eInvoice.errorRetryConflict": "Your previous request is still being processed. Please try again shortly.",
  "profile.fee.eInvoice.errorRefused": "The e-invoice proposal could not be made. Please contact member services.",
  "profile.fee.eInvoice.errorUnavailable": "Requesting the e-invoice proposal did not succeed right now. Please try again shortly.",
  "profile.fee.eInvoice.cancel": "Cancel",
  "profile.fee.eInvoice.confirmation": "Your e-invoice proposal has been sent. It will appear in your online bank within 1–3 business days. Remember to approve it there — the delivery method changes to e-invoice only after you approve it.",
  "profile.fee.eInvoice.description": "When you request an e-invoice proposal, we send a proposal for your membership-fee e-invoice to your online bank. It appears within 1–3 business days depending on your bank.\n\nYou approve the proposal yourself in your online bank. Only after that does the delivery method change to e-invoice, and your membership-fee invoices will then arrive directly in your online bank.\n\nChoose your bank and press Order.",
  "profile.fee.eInvoice.request": "Order e-invoice proposal",
  "profile.fee.eInvoice.placeholder": "Select a bank",
  "profile.fee.eInvoice.sessionExpired": "Your session has expired. Please sign in again and then request the e-invoice proposal.",
  "profile.fee.eInvoice.selectBank": "Bank",
  "profile.fee.eInvoice.submit": "Order",
  "profile.fee.heading": "Membership fee",
  "profile.fee.invoiceDate": "Invoice date",
  "profile.fee.invoiceNumber": "Invoice number",
  "profile.fee.payCta": "Go to payment",
  "profile.fee.payNotPayable": "This invoice cannot be paid in the service right now.",
  "profile.fee.payRetry": "Couldn't start the payment. Please try again.",
  "profile.fee.payUnavailable": "Payment is not available right now.",
  "profile.fee.paymentHistory": "Previous invoices",
  "payment.return.backToFee": "Back to membership fee",
  "payment.return.notCompleted.body": "The payment was not completed. You can go back to the membership fee and try again.",
  "payment.return.notCompleted.heading": "Payment not completed",
  "payment.return.pending.body": "Your payment has been received. Confirmation is still pending — the status will update in the membership-fee view.",
  "payment.return.pending.heading": "Payment received",
  "profile.fee.reference": "Reference number",
  "profile.fee.status": "Status",
  "profile.fee.statusPaid": "Paid",
  "profile.fee.statusPaidPaytrail": "Paid (Paytrail)",
  "profile.fee.statusUnavailable": "Payment status unavailable",
  "profile.fee.statusUnpaid": "Not paid",
  "profile.fee.unavailable": "Membership fee details are not available right now. Please try again later.",
  "profile.hub.certificate": "Membership certificate",
  "profile.hub.contact": "My contact details",
  "profile.hub.fee": "Membership fee",
  "profile.hub.myData": "Stored data",
  "profile.myData.unavailable": "Stored data is not available right now. Please try again later.",
  "profile.memberNumber.copyButton": "Copy member number",
  "profile.memberNumber.copied": "Member number copied",
  "profile.memberNumber.label": "Member number",
  "profile.membershipSummary": "{tier} since {date}",
  "profile.membershipUnavailable": "Membership details are not available right now.",
  "profile.title": "My info",
  "profile.unavailable": "Profile information is not available right now. Please try again later.",
  "profile.verify.cancel": "Cancel",
  "profile.verify.confirm": "My details are up to date",
  "profile.verify.emailSuggestions.label": "Email suggestions",
  "profile.verify.error.city": "Enter a city.",
  "profile.verify.error.email": "Enter a valid email address.",
  "profile.verify.error.phone": "Enter a phone number.",
  "profile.verify.error.postalCode": "Enter a five-digit postal code.",
  "profile.verify.error.street": "Enter a street address.",
  "profile.verify.field.city": "City",
  "profile.verify.field.email": "Email",
  "profile.verify.field.phone": "Phone",
  "profile.verify.field.postalCode": "Postal code",
  "profile.verify.field.street": "Street address",
  "profile.verify.intro": "Please check that your contact details are up to date.",
  "profile.verify.save": "Save",
  "profile.verify.saveError.validation": "Please check your details and try again.",
  "profile.verify.saveError.conflict": "Your details were changed elsewhere. Please review and try again.",
  "profile.verify.saveError.unavailable": "Could not save just now. Please try again in a moment.",
  "profile.verify.saveError.notFound": "Your membership record could not be found. Please contact support.",
  "profile.verify.saveSuccess": "Details saved.",
  "profile.verify.startEdit": "Update details",
  "profile.verify.title": "Check your contact details"
}
